import React from 'react';

const TableDetails = ({ tableDetails }) => {
  if (!tableDetails || !Array.isArray(tableDetails) || tableDetails.length === 0) {
    return <div className="text-gray-600">No table details available.</div>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
        <thead className="bg-[#0000a0]">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Column Name</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Type</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Metadata</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Sample</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {tableDetails.map((column, idx) => (
            <tr key={idx} className="hover:bg-gray-50 transition-colors">
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{column?.name || 'N/A'}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{column?.type || 'N/A'}</td>
              <td className="px-6 py-4 text-sm text-gray-700 max-w-xs truncate" title={column?.metadata}>
                {column?.metadata || 'N/A'}
              </td>
              <td className="px-6 py-4 text-sm text-gray-700 max-w-xs truncate" title={column?.sample}>
                {column?.sample || 'N/A'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableDetails; 